angular.module('avant.conditionalAutoFocus').directive "conditionalAutoFocus", 
["$timeout", ($timeout) ->
  restrict: 'A'
  link: (scope, ele, attrs) ->
    if attrs.conditionalAutoFocus
      scope.$watch attrs.conditionalAutoFocus, (val) ->
        if val
          $timeout ->
            ele[0].focus()
]
